import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import AdminSharedInvites from "../widgets/adminSharedInvites";

const BotpressInvitePortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Invites" />
      <PortalGridContent>
        <Grid item xs={12} sm={12}>
          <AdminSharedInvites />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressInvitePortal);
